export interface ActorBackupSnapshotReader {
  /** Every row of `tables`, read in ONE hold of the connection slot (one committed state). */
  readBackupSnapshot(tables: readonly string[]): Promise<Record<string, unknown[]>>;
}

export interface ActorBackupSnapshotState {
  closed: boolean;
  connection: string;
  databasePath: string;
  idle: boolean;
  version: number;
}

export interface ActorBackupSnapshotSource {
  getBackupSnapshotState(): ActorBackupSnapshotState;
}

export function hasActorBackupSnapshotSource(value: unknown): value is ActorBackupSnapshotSource {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof Reflect.get(value, "getBackupSnapshotState") === "function"
  );
}

const BACKUP_TABLE_NAME = /^[a-z][a-z_]*$/u;

export function actorBackupTableSql(table: string): string {
  if (!BACKUP_TABLE_NAME.test(table)) {
    throw new Error(`Invalid backup table name: ${table}`);
  }
  return `SELECT * FROM "${table}"`;
}

export function hasActorBackupSnapshotReader(value: unknown): value is ActorBackupSnapshotReader {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof Reflect.get(value, "readBackupSnapshot") === "function"
  );
}

export interface ActorBackupRestoreStatement {
  params: unknown[];
  sql: string;
}

export interface ActorBackupRestoreOptions {
  /**
   * Native: save the pre-restore safety backup INSIDE the restore's hold of the connection slot,
   * so no write can land between that backup and the replacement.
   */
  checkpoint?: () => Promise<void>;
}
